/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-undef */
import React from "react";
import { connect } from "react-redux";
import { v4 } from "uuid";
import HomeLayout from "../../Components/ehealth/Layout";
import { formatSeconds, getIcon, toMoney } from "../../Components/Functions";
import { CallToAction } from "../../Components/Utils";
import { loggedUser } from "../../Constants/menus";
import { routers } from "../../Constants/routers";
import { updateSearchParameters, updateSearchResults } from "../../Redux/SearchEngine/actions";
import Api from "../../Server/Api";
import SearchEngineMap from "../maps/SearchEngineMap";
import SearchFilter from "./SearchFilter";


const api = new Api();

export const current = (pageCount, x) => {
	const blockSize = 10;
	const s =  Math.ceil(x/10)*10 - 10;
	if(pageCount - s < blockSize) return pageCount - blockSize;
	return s;
}

export const addRemoveFavourite = async (data, callback) => {
	if(!(loggedUser?.role === "PATIENT")) return;
	const _data = { user: loggedUser.id, specialist: data.id };
	const res = await api.post({ endpoint: "/favourites/", data: _data });
	callback && callback(res)
}

export const SearchResultItem = ({ data, index, searchCategories = [] }) => {
	const [is_favourite, setIsFavourite] = React.useState(data?.is_favourite);
	return (
		<a
			className="flat-list-item map-popup-item "
			data-location={index + 1}
			href={routers.pages.doctor(data.username)}
		>
			<div className="action-bar">
				{loggedUser?.role === "PATIENT" && (
				<button
					className={`button wishlist-button ${
						is_favourite > 0 ? "favourite" : ""
					}`}
					onClick={e => {
						e.preventDefault();
						addRemoveFavourite(data, (res) => {
							setIsFavourite(res?.id)
						})
					}}
				>
					<i
						dangerouslySetInnerHTML={{ __html: getIcon("heart") }}
					/>
				</button>
				)}
			</div>
			<div
				className="list-item-image map-popup-trigger"
				style={{
					background: `url("${
						data?.image || (data?.gender === "MALE"
							? require("../../assets/images/doctor-placeholder-male.jpg")
									.default
							: require("../../assets/images/doctor-placeholder-female.jpg")
									.default)
					}")`,
					backgroundRepeat: "round",
				}}
			/>
			<div className="list-item-content">
				<div className="list-item-info">
					<div className="list-item-precontent">
						<span>{data?.address_lga}, {data?.address_state}</span>
					</div>
					<p className="list-item-name">
						<a>
							{data?.title} {data?.name}{" "}
							<i className={data?.is_verified ? `las la-check-circle text-success` : `las la-x-circle text-danger`}></i>
						</a>
					</p>
					<p className="list-item-details">
						<span>{data?.header_title}</span>
					</p>
				</div>
				<div className="filters py-4">
					<div className="buttons">
						{data?.categories.map((category) => {
							return (
								<button className={`button is-small is-rounded ${searchCategories.includes(category.id) ? "search-cat-outline" : ""}`} key={v4()}>
									{category?.title}
								</button>
							);
						})}
					</div>
				</div>

				<div class="guidelines-item search-engine-item is-flex">
				<span>{toMoney(data.consultation_fee)} per <small>{formatSeconds(data.consultation_fee_duration)}</small></span>
					
				</div>
				<div
					className="list-item-amount"
					style={{ position: "absolute", bottom: 15, right: 15 }}
				>
					<div className="list-item-rating">
						<i
							dangerouslySetInnerHTML={{ __html: feather.icons.star.toSvg() }}
						/>
						<span style={{ marginTop: -5 }}>{data?.avg_rating}</span>
					</div>
				</div>
			</div>
		</a>
	);
};

const SearchEngine = (props) => {
	const search = props?.search;
	const DATA = search?.results || [];
	const searching = props?.searchParameters?.searching;


	const getCategories = () => {
		const filterdCategories = props?.searchParameters?.categories || [];
		return props.categories.filter((e) => filterdCategories.includes(e.id));
	};

	const updateSearchParameters = (e) => {
		props.updateSearchParameters({ ...props?.searchParameters, ...e })
	 }

	const update = () => {
		const params = new URL(window.location).searchParams;
		const category = params.get("category", "");
		const sector = params.get("sector", "");

		const sortBy = params.get("sortBy", "");
		const keyword = params.get("keyword", "");

		// const categories = props.categories.filter((e) => JSON.stringify(e).toLowerCase().includes((category||"").toLowerCase()) && JSON.stringify(e).toLowerCase().includes((sector||"").toLowerCase()))
		// 							.map((e) => { return e.id });
										
		// updateSearchParameters({ categories });
		props.updateSearchResults();

	};

	const gotoPage = (page) => {
		props.updateSearchResults({ page });
	};

	React.useEffect(() => {
		update();
	}, []);
	
	const pageCount = Math.ceil(search?.count / 10);

	return (
		<HomeLayout>
			<style>
				{`
					#pac-input-pickup {
						padding-left: 1rem;
						width: calc(100% - 1rem);
					}

					.mapboxgl-ctrl-geocoder input {
						height: 45px !important;
						padding-left: 3rem;
						border-radius: .75rem;
						background: #fff;
						-webkit-transition: all .3s;
						transition: all .3s;
					}

					input[type="range"] {
						-webkit-appearance: none;
						margin-right: 15px;
						width: 200px;
						max-height: 5px;
						background: rgba(0, 0, 0, 0.2);
						border-radius: 5px;
						margin-top: 1rem;
						margin-bottom: 1rem;
					  }
					  
					  input[type="range"]::-webkit-slider-thumb {
						-webkit-appearance: none;
						height: 20px;
						width: 20px;
						border-radius: 20px;
						background: #37514b !important;
						cursor: ew-resize;
						box-shadow: 0 0 2px 0 #37514b;
						transition: background .3s ease-in-out;
					  }
					  
					  input[type=range]::-webkit-slider-runnable-track  {
						-webkit-appearance: none;
						box-shadow: none;
						border: none;
						background: transparent;
					  }
					  
				`}
			</style>
			<div className="dual-container">
				<div className="dual-container-left">
					<div className="left-header">
						<h4>Search Results</h4>
						<h2 className="title is-3 is-narrow">
							Find your nearest doctor
						</h2>
						<div className="filters py-4">
							<SearchFilter />
						</div>
					</div>
					{/*Carousel offers*/}

					<div className="flat-list py-6">
			
						<div className="flat-list-inner">
							{/*List item*/}
							{searching && (
								 <>
								 <style>
									 {`
									 	.pageloader.pageloader-2 {
											position: relative;
											width: 100%;
											min-height: 650px;
											border-radius: 10px;
										}
									 `}
								 </style>
								 <div id="pageloader" className="pageloader pageloader-2 is-left-to-right is-active" />
								 <p>Updating search result, please wait...</p>
								 </>
							)|| (
								<>
								{(DATA?.length > 0 &&
								DATA.map((result, i) => {
									return <SearchResultItem searchCategories={props?.searchParameters?.categories} data={result} index={i} />;
								})) || (
								<div className="section-placeholder">
									<div className="placeholder-content search-engine">
										<img
											className="light-image"
											src={
												require("../../assets/img/illustrations/placeholders/search-4.svg")
													.default
											}
											alt=""
											style={{ width: "100%" }}
										/>
										<h3 className="dark-inverted">No data to show</h3>
										<p>There is currently no data to show in this list.</p>
									</div>
								</div>
							)}
								</>
							)}
							
						</div>
					</div>
					{DATA?.length > 0 && (
						<nav
							className="pagination map-pagination is-centered is-rounded mt-4 mb-6"
							role="navigation"
							aria-label="pagination"
						>
							{search?.previous !== null && (
								<a
									className="pagination-previous"
									href="#"
									onClick={(e) => {
										e.preventDefault();
										gotoPage(search?.current - 1);
									}}
								>
									Previous
								</a>
							)}
							{search?.next !== null && (
								<a
									className="pagination-next"
									href="#"
									onClick={(e) => {
										e.preventDefault();
										gotoPage(search?.current + 1);
									}}
								>
									Next
								</a>
							)}

							<ul className="pagination-list">
								{
									[...Array(pageCount).keys()]
									.slice(current(pageCount, search?.current), current(pageCount, search?.current) + 10)
									.map((i) => {
										return (
											<li>
												<a
													className={`pagination-link ${
														search.current === i + 1 ? "is-current" : ""
													}`}
													href="#"
													onClick={(e) => {
														e.preventDefault();
														gotoPage(i + 1);
													}}
												>
													{i + 1}
												</a>
											</li>
										);
									})}
							</ul>
						</nav>
					)}
				</div>
				<SearchEngineMap />
			</div>
			<div className="container bg-white">
				<CallToAction className={"cta-search-bottom"} />
			</div>
		</HomeLayout>
	);
};

const mapStateToProps = ({ search, searchParameters, categories }) => {
	return {
		search,
		searchParameters,
		categories: categories.allcategories,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		updateSearchResults: (e) => dispatch(updateSearchResults(e)),
		updateSearchParameters: (e) => dispatch(updateSearchParameters(e))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchEngine);
